import React, { useEffect } from "react";
import { Link } from "gatsby";
import { navigate } from "@reach/router";

const Navigation = props => {
  const handleKeys = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      return;
    }

    if (event.key === 'ArrowLeft') {
      navigate(props.prevSlide);
    }

    if (event.key === 'ArrowRight' && props.showNext) {
      navigate(props.nextSlide);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeys);

    return () => {
      window.removeEventListener('keydown', handleKeys);
    };
  });
  
  return (
    <div className="navigation">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <Link to={props.prevSlide} id="btn-prev" className="btn btn-ghost">Prev</Link>
            {props.showNext && (
              <Link to={props.nextSlide} id="btn-next" className="btn btn-orange">Next</Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
